import { makeApi } from "@zodios/core";
import { z } from "zod";

import { kiliProgrammingIsSuspendedOnSiteSchema } from "@/types/kili/programming/kili-programming-is-suspended-on-site.type.ts";

export const kiliProgrammingApi = makeApi([
  {
    method: "post",
    path: "/suspend-site/:siteId",
    alias: "suspendSiteProgramming",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
    response: z.any(), // 204 no content
  },
  {
    method: "post",
    path: "/resume-site/:siteId",
    alias: "resumeSiteProgramming",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
    response: z.any(), // 204 no content
  },
  {
    method: "get",
    path: "/is-suspended-on-site/:siteId",
    alias: "findIsProgrammingSuspendedOnSite",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
    response: kiliProgrammingIsSuspendedOnSiteSchema,
  },
]);
